import { render, staticRenderFns } from "./Session.vue?vue&type=template&id=0a84ec35&"
import script from "./Session.vue?vue&type=script&lang=ts&"
export * from "./Session.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports